<template>
  <div id="app" style="min-width: 490px;">
    <router-view></router-view>
  </div>
</template>

<script>
import { version } from "./../package.json"
export default {
  name: 'app',
  
  created() {
    window.$crisp.push(["set", "session:data", ["front_version", version]]);
  }
}
</script>

<style src="./assets/scss/style.scss" lang="scss"></style>